/*global angular */
/*jslint node: true */

'use strict';

var spacer = angular.module('spacer', []);
spacer.directive('spacerSlot', ['$templateCache', function ($templateCache) {
    return {
        restrict: 'E',
        template: $templateCache.get('slots/spacer/spacer.html')
    };
}]);
